module.exports = __webpack_public_path__ + "img/recherche.f659d924.png";